// sections/DetailProductsSection.tsx

import { usePayableDetail } from "../../hooks/usePayableDetail";

const DetailProductsSection = () => {
  const { detail } = usePayableDetail();

  if (!detail?.products?.length) return null;

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Productos Relacionados
      </h4>

      <div className="space-y-4">
        {detail.products.map((product: any, index: number) => (
          <div
            key={product.productId || product.rawMaterialId || index}
            className="
              rounded-lg
              border border-gray
              bg-gray-2
              p-4
              dark:border-strokedark
              dark:bg-boxdark-2
            "
          >
            <div className="grid grid-cols-1 gap-4 md:grid-cols-5">
              {/* Producto */}
              <div>
                <p className="mb-1 text-sm text-body dark:text-bodydark">
                  Producto
                </p>

                <p className="font-semibold text-black dark:text-white">
                  {product.productName || product.rawMaterialName || "-"}
                </p>
              </div>

              {/* Código */}
              <div>
                <p className="mb-1 text-sm text-body dark:text-bodydark">
                  Código
                </p>

                <p className="font-medium text-black dark:text-white">
                  {product.productCode || product.rawMaterialCode || "-"}
                </p>
              </div>

              {/* Cantidad */}
              <div>
                <p className="mb-1 text-sm text-body dark:text-bodydark">
                  Cantidad
                </p>

                <p className="font-medium text-black dark:text-white">
                  {product.quantity || 0}
                </p>
              </div>

              <div>
                <p className="mb-1 text-sm text-body dark:text-bodydark">
                  Precio / costo unitario
                </p>

                <p className="font-medium text-black dark:text-white">
                  ${Number(
                    product.unitPrice ?? product.unitCost ?? 0
                  ).toFixed(2)}
                </p>
              </div>

              {/* Total */}
              <div>
                <p className="mb-1 text-sm text-body dark:text-bodydark">
                  Total
                </p>

                <p className="font-bold text-primary">
                  ${Number(
                    product.totalAmount ?? product.total ?? 0
                  ).toFixed(2)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DetailProductsSection;
